import './App.css';
import React, {useEffect, useRef} from 'react';
import {useScroll} from 'motion/react';
import {AnimatePresence} from 'framer-motion'
import {BrowserRouter, useLocation} from 'react-router-dom';
import Router from './page/router';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavBar from './component/navBar';
import Footer from './component/footer';
import ScrollToTopButton from "./component/scrollToTopButton";
import {AuthProvider} from "./context/authContext";
import useChannelTalk from "./hook/useChannelTalk";
import ReactGA from 'react-ga4';

const App = () => {

    useChannelTalk();
    const rootRef = useRef(null);
    const {scrollYProgress} = useScroll({
        container: rootRef,
    });
    useEffect(() => {
        ReactGA.initialize('G-FQRMG3PJZ0');

    }, []);
    useEffect(()=>{
        if(window.location.pathname === '/'){
            window.location.href = 'https://sinor.co.kr/silovematch';
        }
    },[])
    return (
        <AuthProvider>
            <div
                ref={rootRef}
                className=".scrollRoot"
                style={{
                    overflowY: 'scroll',
                    scrollBehavior: 'smooth',
                    margin: 0,
                    height: '100vh',
                    position: 'relative',
                }}
            >
                <AnimatePresence>
                    <BrowserRouter>
                        {/*<NavBar progress={scrollYProgress} rootRef={rootRef}/>*/}
                        <Router rootRef={rootRef}/>

                        {/*<Footer/>*/}
                        <ScrollToTopButton/>
                    </BrowserRouter>
                </AnimatePresence>
            </div>
        </AuthProvider>
    );
};

export default App;
